<template>
  <div>
    <b-button
      v-permission="'influencer_levels.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon icon="PlusIcon" class="mr-50"/>
      <span class="align-middle">{{ $t('AddNew') }}</span>
    </b-button>

    <Grid :service="service" route_name="influencer_levels" order_column="rank">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="rank" sort-key="rank">{{ $t('influencer_level.rank') }}</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('influencer_level.name') }}</vs-th>
        <vs-th key="requirements">{{ $t('influencer_level.requirements') }}</vs-th>
        <vs-th key="bonus">{{ $t('influencer_level.bonus') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('influencer_level.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">{{ tr.id }}</vs-td>
          <vs-td width="8%" key="rank">{{ tr.rank }}</vs-td>
          <vs-td width="22%" key="name">
            <vs-chip transparent :color="tr.badge_color || 'primary'">{{ tr.name }}</vs-chip>
          </vs-td>
          <vs-td width="35%" key="requirements">
            <small class="text-muted">{{ requirementsLabel(tr) }}</small>
          </vs-td>
          <vs-td width="12%" key="bonus">+{{ Number(tr.commission_bonus_pct || 0) }}%</vs-td>
          <vs-td width="10%" key="status">
            <vs-chip transparent :color="tr.status === 'AC' ? 'success' : 'warning'">
              {{ tr.status === 'AC' ? $t('active') : $t('inactive') }}
            </vs-chip>
          </vs-td>
          <vs-td width="8%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'influencer_levels.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'influencer_levels.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import InfluencerLevelService from '@/services/api/InfluencerLevelService'

export default {
  directives: { Ripple },
  components: { BButton },
  data: () => ({ service: null }),
  methods: {
    addNew() {
      this.$router.push('/influencer_levels/create')
    },
    /** Requisito nulo não é exigência — some da lista em vez de virar "0". */
    requirementsLabel(level) {
      const parts = []
      if (level.min_followers) parts.push(`${level.min_followers} seguidores`)
      if (level.min_conversions) parts.push(`${level.min_conversions} vendas`)
      if (level.min_sales_amount) parts.push(`R$ ${Number(level.min_sales_amount).toLocaleString('pt-BR')} em GMV`)
      return parts.length ? parts.join(' · ') : this.$t('influencer_level.no_requirements')
    }
  },
  beforeMount() {
    this.service = InfluencerLevelService.build(this.$vs)
  }
}
</script>
